export type Breadcrumb = {
  label: string;
  url: string;
};

export const BREADCRUMB_ROUTE_KEY = "breadcrumb";
export const BREADCRUMB_FORCE_URL_KEY = "breadcrumbForceUrl";
